import { useEffect } from 'react'
import { useCallStore } from '../stores/callStore'

/**
 * ページ可視性の変化を監視し、Wake Lockを管理するカスタムフック
 * 受付中にページが再表示された際に自動的にWake Lockを再獲得
 */
export function useWakeLockManager(ringAudioEnabled: boolean): void {
  const { requestWakeLock } = useCallStore()

  useEffect(() => {
    const handleVisibilityChange = async () => {
      // ページが再び表示され、かつ受付中の場合、Wake Lockを再獲得
      if (document.visibilityState === 'visible' && ringAudioEnabled) {
        console.log('ページが表示されました - Wake Lockを再獲得します')
        await requestWakeLock()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [ringAudioEnabled, requestWakeLock])
}
